import listenForResponseOnVoiceCallContent from './listenForResponseOnVoiceCallContent';

const listenForResponseOnVoiceCall = {
  name: 'Listen for response on Voice Call',
  Content: listenForResponseOnVoiceCallContent,
  setInitialContent: () => {
    return {};
  },
  valid: () => {
    return true;
  }
};

export default listenForResponseOnVoiceCall;
